module.exports = __webpack_public_path__ + "img/product-7-mobileINTqinyou.43d90267.png";